// extracted by mini-css-extract-plugin
module.exports = {"select":"actionsHito_select__2Pwma","tdSection":"actionsHito_tdSection__2t1Ww"};